export const SIGN_IN_REDUCER_KEY = 'signInForm';
export const LOCATION_REDUCER_KEY = 'location';
export const USER_REDUCER_KEY = 'user';
export const BOOKING_REDUCER_KEY = 'booking';
